import ZariMultiple from './multiple'
import ZariMultipleItem from './item'

ZariMultiple.Item = ZariMultipleItem

export default ZariMultiple
